// extracted by mini-css-extract-plugin
export var link = "styles-module--link--8e7ac";